import "../../CommonImports";
import "../../Core/core.css";
import "./List.css";
import "./ListDropIndicator.css";
import * as React from "react";
import { getPointByEventType } from '../../Util';
import { cellFromEvent } from "./List";
import { ListDropIndicator } from "./ListDropIndicator";
/**
 * A behavior that turns a list into the target of a drag and drop operation. Note - this
 * behavior should only be used if your list is intended to _only_ be a drop target. Please use
 * the ListDragDropBehavior instead if the list is also a drag source, as that is the only way
 * to get keyboard drag and drop support within your list.
 */
var ListDropTargetBehavior = /** @class */ (function () {
    function ListDropTargetBehavior(options) {
        var _this = this;
        this.initialize = function (props, dragDroppableUI, eventDispatch) {
            _this.dragDroppableUI = dragDroppableUI;
            _this.eventDispatch = eventDispatch;
            _this.eventDispatch.addEventListener("dragenter", _this.onDragEnter);
            _this.eventDispatch.addEventListener("dragexit", _this.onDragExit);
            _this.eventDispatch.addEventListener("dragover", _this.onDragOver);
            _this.eventDispatch.addEventListener("drop", _this.onDrop);
            _this.itemProvider = props.itemProvider;
        };
        this.onDragEnter = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            if (_this.options.onDragEnter) {
                _this.options.onDragEnter(event);
            }
            else {
                event.detail.dataTransfer.dropEffect = "move" /* move */;
            }
        };
        this.onDragExit = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            if (_this.options.onDragExit) {
                _this.options.onDragExit(event);
            }
            _this.dragDroppableUI.removeOverlay("drop-indicator");
        };
        this.onDragOver = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            var index = _this.calculateIndex(event);
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            if (index >= 0 && (index !== dragIndex || listId !== _this.options.id)) {
                if (_this.options.onDragOver) {
                    _this.options.onDragOver(event, { index: _this.listIndicatorPosition === 0 /* bottom */ ? index + 1 : index });
                }
                else {
                    event.detail.dataTransfer.dropEffect = "move" /* move */;
                }
            }
            else {
                event.detail.dataTransfer.dropEffect = "none" /* none */;
            }
            if (event.detail.dataTransfer.dropEffect === "none" /* none */) {
                _this.dragDroppableUI.removeOverlay("drop-indicator");
            }
            else {
                _this.dragDroppableUI.addOverlay("drop-indicator", index, _this.renderDropIndicator);
            }
        };
        this.onDrop = function (event) {
            if (!_this.handlesType(event)) {
                return;
            }
            var index = _this.calculateIndex(event);
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            if (index >= 0 && (index !== dragIndex || listId !== _this.options.id) && _this.options.onDrop) {
                _this.options.onDrop(event, { index: _this.listIndicatorPosition === 0 /* bottom */ ? index + 1 : index });
            }
            _this.dragDroppableUI.removeOverlay("drop-indicator");
        };
        this.renderDropIndicator = function (props) {
            return React.createElement(ListDropIndicator, { position: _this.listIndicatorPosition });
        };
        this.options = options;
    }
    ListDropTargetBehavior.prototype.componentDidUpdate = function (props) {
        this.itemProvider = props.itemProvider;
    };
    ListDropTargetBehavior.prototype.componentWillUnmount = function () {
        this.eventDispatch.removeEventListener("dragenter", this.onDragEnter);
        this.eventDispatch.removeEventListener("dragexit", this.onDragExit);
        this.eventDispatch.removeEventListener("dragover", this.onDragOver);
        this.eventDispatch.removeEventListener("drop", this.onDrop);
    };
    ListDropTargetBehavior.prototype.calculateIndex = function (event) {
        var cell = cellFromEvent(event);
        var index = cell.rowIndex;
        if (cell.rowElement && event.detail.dataTransfer.secondaryData) {
            var dragIndex = event.detail.dataTransfer.secondaryData.index;
            var listId = event.detail.dataTransfer.secondaryData.sourceId;
            var nativeEvent = event.detail.nativeEvent;
            var rowRect = cell.rowElement.getBoundingClientRect();
            var point = getPointByEventType(nativeEvent);
            var topHalfOfRow = point ? point.y < rowRect.height / 2 + rowRect.top : index < dragIndex;
            if (this.options.id !== listId) {
                this.listIndicatorPosition = 1 /* top */;
                if (!topHalfOfRow) {
                    index++;
                }
                if (index >= this.itemProvider.length) {
                    this.listIndicatorPosition = 0 /* bottom */;
                    index--;
                }
            }
            else {
                if (index < dragIndex) {
                    this.listIndicatorPosition = 1 /* top */;
                    if (!topHalfOfRow) {
                        index++;
                    }
                }
                else if (index > dragIndex) {
                    this.listIndicatorPosition = 0 /* bottom */;
                    if (topHalfOfRow) {
                        index--;
                    }
                }
                // No-op if index === dragIndex
            }
        }
        return index;
    };
    ListDropTargetBehavior.prototype.handlesType = function (event) {
        var type = event.detail.dataTransfer.type || "";
        return this.options.allowedTypes.indexOf(type) !== -1;
    };
    return ListDropTargetBehavior;
}());
export { ListDropTargetBehavior };
